import "core-js/modules/es.string.bold.js";
import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Number = styled(Text).withConfig({
  displayName: "Readout__Number",
  componentId: "sc-oqox2a-0"
})(["vertical-align:-1px;"]);
var Readout = function Readout(_ref) {
  var bold = _ref.bold,
    value = _ref.value,
    children = _ref.children;
  return /*#__PURE__*/_jsxs(Text, {
    bold: bold,
    children: [/*#__PURE__*/_jsx(Number, {
      bold: true,
      size: "xl",
      display: "inline-block",
      lineHeight: 1,
      mr: "xxs",
      children: value
    }), ' ', children]
  });
};
export default Readout;